import { ResponsiveView, ResponsiveSizeContainer, FixedSizeFitContainer } from "../../../singlegame/ResponsiveHelpers";
import { AudioManager, Track } from "../../AudioManager";
import { IInterval } from "../../Context/Interval";
import { ISystemContext } from "../../Context/SystemContext";
import { JackpotDisplayProperties } from "../../JackpotDisplayProperties";
import { LogGroup, Log, Scale, Safe } from "../../MyHelpers";
import { DecodedImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings } from "../../Settings";
import { ITransition } from "./ITransition";
import { ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import * as PIXI from "pixi.js";
import { TweenMax } from "gsap";


export class ImgTransitionPIXI implements ITransition {
    protected systemContext: ISystemContext = null;
    protected params: ITransitionParamsPIXIAPP = null;

    protected view: HTMLElement = null;
    protected audio: AudioManager = null;
    protected resid: ResourceIdentifier = null;
    protected logGroup: LogGroup = null;
    protected gameName: string = null;

    protected startTimeoutFideOut: IInterval = null;
    protected startTimeFadeIn: IInterval = null;

    protected jackpotName: string;

    public constructor(params: ITransitionParamsPIXIAPP) {
        this.params = params;
        this.resid = params.resid;
        this.audio = params.audio;
        this.logGroup = params.logGroup
        this.gameName = params.gameName;
        this.systemContext = params.systemContext;
        //this.spriteResource = params.spriteResource;

        //if(params.spriteResource != null)
        this.fadeOut = params.fadeOut;

        //this.track = params.soundResource;
        //this.videoResource = params.videoResource;
        //this.nameResource = params.nameResource;
        this.jackpotName = Settings.JackpotDisplayType;
        if (JackpotDisplayProperties[Settings.JackpotDisplayType].alias) {
            this.jackpotName = JackpotDisplayProperties[Settings.JackpotDisplayType].alias;
        }
        this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));

        this.startTimeoutFideOut = this.params.systemContext.TimingContext().CreateTimeout("startTimeoutFideOut", 2800, () => {
            TweenMax.to(this.view, 1, {
                autoAlpha: 0, display: "none",
                onStart: () => {
                    this.OnTransitionEnded();
                    this.responsiveView.visible = false;
                }, onComplete: () => {
                    //this.TitleSpriteTransition.View().style.display = "none";
                    // setTimeout(() => {
                    // if(this.TitlePIXIAnimatedSprite != null) this.TitlePIXIAnimatedSprite.alpha = 0;
                    // if(this.titleSpine != null){                            
                    //     this.titleSpine.visible = false;
                    // }
                    this.DestroyTransitionPixi();
                    // }, 500);
                }
            });
        });

        this.startTimeFadeIn = this.params.systemContext.TimingContext().CreateInterval("startTimeFadeIn", 10, () => {
            // let groupSize = 5 * Settings.Screens;

            // for (let indexGroup = 0; indexGroup < groupSize; indexGroup++)
            // {
            //     if (this.fadeInParticleIndex >= this.arrayParticles.length)
            //     {
            //         console.log(`Stop fade in, particles: ${this.fadeInParticleIndex}`);
            //         this.fadeInParticleIndex = 0;
            this.startTimeFadeIn.Stop();
            //         if(this.TitlePIXIAnimatedSprite != null){
            //             this.TitlePIXIAnimatedSprite.alpha = 1;
            //             this.TitlePIXIAnimatedSprite.play();
            //         } 
            //         if(this.titleSpine != null){
            //             this.titleSpine.visible = true;
            //             this.titleSpine.state.setAnimation(0,"idle",false);
            //         }
            this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
            // break;
            // }


            //this.arrayParticles[this.fadeInParticleIndex].parent.setChildIndex(this.arrayParticles[this.fadeInParticleIndex], this.fadeInParticleIndex);
            //this.arrayParticles[this.fadeInParticleIndex].scale.set(1 + Math.random()); //scale 1 to 2 randomly (random gives numbers between 0 and 1)
            // this.arrayParticles[this.fadeInParticleIndex].alpha = 1;

            // this.fadeInParticleIndex++;
            // }
        });

    }
    ViewPIXIAPP(): PIXI.Container {
        return this.viewContainer;
    }

    //protected backgroundImgBaseTexture:PIXI.BaseTexture = null;
    protected backgroundTexture: PIXI.Texture = null;

    protected fadeOut: boolean;


    protected fadeSettings() {

        if (this.fadeOut == true) {
            //this.TitleSpriteTransition.View().style.display = "block";                  
            //this.TitleSpriteTransition.Start(false);
            this.startTimeoutFideOut.Start();
        }
        else {

        }

    }

    public async PrepareResources(resourceManager?: IWriteOnlyResourceManager): Promise<void> {

        if (this.params.bonusName == "FreeGameBonus") {
            resourceManager.Add(new SpriteResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/FreeGameBonus/resources/freegameTitle`, this.resid.Add("Bonus-Title"), true, this.logGroup.Add("Bonus-Title"), true));
            resourceManager.Add(new DecodedImageResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/FreeGameBonus/background1S/background.png`, ResourceIdentifier.Global.ScopedResourceName("TransitionBackground")));
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));

        }
        else {
            resourceManager.Add(new SpriteResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/HoldAndSpin/resources/diamondpot`, this.resid.Add("Bonus-Title"), true, this.logGroup.Add("Bonus-Title"), true));
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/tracks/" + this.jackpotName + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));

        }

    }

    protected frames: PIXI.Texture[] = [];
    protected titleAnimatedSprite: PIXI.AnimatedSprite = null;
    protected bonusTitleSpriteResource: SpriteResource = null;
    protected freegameTitleSpriteResource: SpriteResource = null;

    public async ResourcesLoaded(resourceManager?: IReadOnlyResourceManager): Promise<void> {

        let backgroundImg = resourceManager.Get<DecodedImageResource>(ResourceIdentifier.Global.ScopedResourceName("TransitionBackground"));
        this.backgroundTexture = PIXI.Texture.from(backgroundImg.DecodedImage());

        this.bonusTitleSpriteResource = resourceManager.Get<SpriteResource>(this.resid.ScopedResourceName("Bonus-Title"));

        this.createTitleAnimatedSprite();

    }

    protected createTitleAnimatedSprite() {
        for (let i = 0; i <= this.bonusTitleSpriteResource.sprite.NumFrames() - 1; i++) {
            let texture = PIXI.Texture.from(this.bonusTitleSpriteResource.sprite.GetDecodedFrame(i));
            this.frames.push(texture);
        }

        this.titleAnimatedSprite = new PIXI.AnimatedSprite(this.frames);
        // this.titleAnimatedSprite.scale.set(0.65);
        // this.titleAnimatedSprite.width = Scale.W(1920);
        // this.titleAnimatedSprite.height = Scale.H(1080);

    }



    protected started: boolean = false;
    public ShowTransiton(): void {
        if (this.started == false) {
            this.OnTransitionStarted();
            // TweenMax.to(this.view, 0.8, {
            //     autoAlpha: 1, display: "flex", onComplete: () => {
            //     }
            // });


            // set alpha 0 to all particles           
            TweenMax.set(this.view, { autoAlpha: 1, display: "flex" });
            this.started = true;
            this.startTimeFadeIn.Restart();

            // shuffle and restart
            this.fadeSettings();
        }
    }
    public View(): HTMLElement {

        return this.view;
    }
    public Update(): void {

    }
    public onTransitionStart: () => void;
    public onTransitionEnd: () => void;

    protected viewContainer: PIXI.Container = null;
    protected created: boolean = false;

    public CreateTransitionPixi(app: PIXI.Container) {

        this.viewContainer = app;
        this.created = true;
        this.Create();
    }

    protected backgroundImg: PIXI.Sprite = null;
    protected bonusTitleSprite: PIXI.Sprite = null;

    protected Create() {
        this.created = true;
        {
            this.InternalCreate();
        }

    }

    public OnTransitionStarted() {
        Log.Debug(this.logGroup, "Transition started");

        this.responsiveView.visible = true;
        this.titleAnimatedSprite.animationSpeed = 1;
        this.titleAnimatedSprite.play();

        this.onTransitionStart?.();
    }

    public OnTransitionEnded(): void {
        Log.Debug(this.logGroup, "Transition ended");
        this.started = false;
        this.onTransitionEnd?.();
    }

    protected responsiveView: ResponsiveView = null;
    protected transitionContainer: ResponsiveSizeContainer = null;

    protected bonusTitleFixedContainer: FixedSizeFitContainer = null;
    protected titleContainer: PIXI.Container = null;

    protected InternalCreate() {
        if (!this.viewContainer) return;

        if (this.frames.length == 0) this.createTitleAnimatedSprite();

        // this.backgroundImg = new PIXI.Sprite(new PIXI.Texture(this.backgroundImgBaseTexture));
        // this.backgroundImg.width = window.innerWidth;
        // this.backgroundImg.height = window.innerHeight;


        this.responsiveView = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: 'responsive-view-transition-img' });

        this.transitionContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, { color: 0x990000, name: 'transition-img-container' });
        this.responsiveView.addChild(this.transitionContainer);


        // this.transitionContainer.addChild(this.backgroundImg);


        this.responsiveView.visible = false;
        // this.transitionContainer.addChild(this.backgroundImg);

        // this.transitionBackgroundFixedContainer = new FixedSizeContainer(window.screen.availWidth, window.screen.availHeight, {color: 0x990000, name: 'transition-img-container-fixed'});
        // this.transitionBackgroundFixedContainer.addChild(this.backgroundImg);

        // this.transitionContainer.addChild(this.transitionBackgroundFixedContainer);
        this.bonusTitleFixedContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0x990000, name: 'transition-img-container-fixed' });
        this.transitionContainer.addChild(this.bonusTitleFixedContainer);

        this.titleContainer = new PIXI.Container();
        this.titleContainer.name = "titleContainer";
        this.titleContainer.addChild(this.titleAnimatedSprite);

        // titleContainer.width = Scale.W(1920);
        // titleContainer.height = Scale.H(1080);

        // titleContainer.position.set(0,0);        

        // this.transitionBackgroundFixedContainer.addChild(titleContainer);
        // titleContainer.position.set(window.screen.availWidth/2 - titleContainer.width/2,window.screen.availHeight/2 - titleContainer.height/2);

        this.bonusTitleFixedContainer.addChild(this.titleContainer);

        // this.bonusTitleFixedContainer.addChild(this.titleAnimatedSprite);

        // titleContainer.position.x = 0;
        // titleContainer.position.y = 0;

        // this.titleAnimatedSprite.scale.set(1);

        // if (GetOrientation() == Orientation.Landscape)
        // {
        // this.titleAnimatedSprite.scale.set(0.65);
        // titleContainer.position.x = (window.screen.availWidth/2 - this.titleAnimatedSprite.width/2)+Scale.X(300);
        // titleContainer.position.y = (window.screen.availHeight/2 - this.titleAnimatedSprite.height/2)+Scale.Y(200);

        // }
        // else
        // {
        // this.titleAnimatedSprite.scale.set(1.5);
        // titleContainer.position.x = (window.screen.availWidth/2 - this.titleAnimatedSprite.width/2)+Scale.X(2000);
        // titleContainer.position.y = (window.screen.availHeight/2 - this.titleAnimatedSprite.height/2)+Scale.Y(800);
        // }
        // titleContainer.position.set(window.screen.availWidth/2 - titleContainer.width/2, window.screen.availHeight/2 - titleContainer.height/2);

        // this.responsiveView.addChild(/*this.transitionBackgroundFixedContainer,*/ this.bonusTitleFixedContainer);


        this.viewContainer.addChild(this.responsiveView);
        this.createBackgroundImg();

        this.OnResize();

    }

    public DestroyTransitionPixi() {

        // this.titleAnimatedSprite?.stop();
        this.frames = [];

        if (!this.created) {
            Log.Debug(this.logGroup, `Destroy() FillingPot: no app, not destroying anything`);
            return;
        }

        this.created = false;

        // Safe(() => this.viewContainer?.removeChildren());
        // Safe(() => this.viewContainer?.removeFromParent());
        Safe(() => this.responsiveView?.destroy({ children: true }));
        // Safe(() => this.transitionBackgroundFixedContainer?.destroy({children: true}));
        Safe(() => this.backgroundImg?.destroy({ texture: true, baseTexture: true }));
        Safe(() => this.titleAnimatedSprite?.destroy({ children: true }));
        Safe(() => this.transitionContainer?.destroy({ children: true }));
    }

    // protected allowResize: boolean = true;
    protected backgroundContainer: PIXI.Container = null;

    private createBackgroundImg() {

        this.backgroundImg = new PIXI.Sprite(this.backgroundTexture);
        this.backgroundImg.width = Scale.W(1920);//window.screen.availWidth;
        this.backgroundImg.height = Scale.H(1080);//window.screen.availHeight;
        this.backgroundImg.pivot.set(Scale.W(1920) / 2, Scale.H(1080) / 2);

        this.backgroundContainer = new PIXI.Container();
        this.backgroundContainer.name = "backgroundContainerImg";
        this.backgroundContainer.addChild(this.backgroundImg);

        // this.backgroundImg.x = (window.screen.availWidth - this.backgroundImg.width) / 2;
        // this.backgroundImg.y = (window.screen.availHeight - this.backgroundImg.height) / 2;

        this.responsiveView.addChildAt(this.backgroundContainer, 0);

    }

    public OnResize() {

        if (!this.created) return;

        this.responsiveView?.setAvailableSize(window.innerWidth, window.innerHeight);

        const scaleX = window.innerWidth / this.backgroundImg.texture.width;
        const scaleY = window.innerHeight / this.backgroundImg.texture.height;

        const scale = Math.max(scaleX, scaleY);
        this.backgroundImg.scale.set(scale);

        if (this.params.bonusName == "FreeGameBonus"){

            const scaleXFG = this.bonusTitleFixedContainer.fixedWidth / this.titleAnimatedSprite.width;
            const scaleYFG = this.bonusTitleFixedContainer.fixedHeight / this.titleAnimatedSprite.height;
            const scaleFG = Math.min(scaleXFG, scaleYFG);
            this.titleAnimatedSprite.scale.set(scaleFG * 0.6);
            
        }

        this.titleContainer.position.x = this.bonusTitleFixedContainer.fixedWidth / 2 - (this.titleContainer.width) / 2;
        this.titleContainer.position.y = this.bonusTitleFixedContainer.fixedHeight / 2 - this.titleContainer.height / 2;

        this.backgroundImg.position.x = window.innerWidth / 2;
        this.backgroundImg.position.y = window.innerHeight / 2;

    }


}